module.exports = __webpack_public_path__ + "img/12219_19.3103057a.png";